import _ from 'lodash'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import license from 'scoreboard/components/license'
import template from './copy-group-dialog.hbs'

const CopyGroupDialog = Backbone.View.extend({
	tagName: 'form',

	className: 'copy-group-dialog',

	//** @type {Group} */
	model: null,

	/**
	 * Dialog for copying an existing group
	 * @param {Object} options
	 * @param {Group} options.model a cloned Group
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this),
			submitSecondary: this.submitSecondary.bind(this)
		})
		this.originalId = _.get(this.model, 'id')
	},

	render: function () {
		let title = i18n.get('common.copy.withArg',
			'<q>' + _.escape(this.model.get('label')) + '</q>')
		let instructions = i18n.get('admin.group.copy.instructions')
		this.$el.empty().append(template({
			title,
			instructions,
			datasets: license.datasets
		}))
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start()
		let defaultLabel = i18n.get('common.copy.defaultName', this.model.get('label'))
		this.$('[name=label]').val(defaultLabel)
		return this
	},

	prepareCopyGroup: function () {
		let id = this.model.id
		// #31962 In new group creation, dataset permissions with principal IDs are filtered out since they aren't new.
		// When copying a group, we need to set the desired principal IDs to null so that they appear new and are not filtered out.
		let datasets = this.model.attributes.datasets
		_.each(datasets, dataset => {
			let permissions = dataset.permissions
			_.each(permissions, permission => {
				if (permission.principal.id === id) {
					permission.principal.id = null
				}
			})
		})
		this.model.unset('id')
		let data = formHelper.readFromDom(this.el)

		// #54825
		// Ensure admins are not always copied over to reflect the user's
		// copy checkbox options
		_.each(['admins', 'datasets', 'members', 'orgPermissions'], key => {
			if (!data[key]) {
				this.model.unset(key)
			}
		})
		this.model.set('label', data.label)
	},

	/**
	 * "Copy" Button
	 */
	submit: function (opts) {
		let itemId = this.originalId
		let edit = _.get(opts, 'edit')
		this.prepareCopyGroup()
		return this.model.save({}, {
			success: (result) => {
				Backbone.trigger('add:domain-object', this.model)
				if (edit) {
					itemId = result.id
				}
				// admin-groups.js / admin-two-column-editor.js rely on `itemId` naming
				this.trigger('done', {itemId})
			},
			error: (model, xhr) => this.formView.error(xhr)
		})
	},

	/**
	 * "Copy & Edit" Button
	 */
	submitSecondary: function () {
		this.submit({edit: true})
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelField], 'remove')
	}

})

export default CopyGroupDialog
CopyGroupDialog.__filename__ = 'admin/principals/groups/copy-group-dialog.js'
